import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import defaultChefImage from "../assets/images/chef-nosotros.jpg";
import { Utensils, CheckCircle, Coffee, CakeSlice } from "lucide-react";

const Nosotros = () => {
  const [nosotrosImageUrl, setNosotrosImageUrl] = useState(defaultChefImage);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "nosotros_image_url")
        .single();

      if (error && error.code !== "PGRST116") {
        console.error("Error fetching 'nosotros' image:", error);
      }

      if (data?.value) {
        setNosotrosImageUrl(data.value);
      }
      setLoading(false);
    };
    fetchImage();
  }, []);

  return (
    <div className="bg-white">
      {/* Hero con overlay */}
      <div className="relative bg-gray-900">
        <img
          src={nosotrosImageUrl}
          alt="Chef"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="relative z-10 text-center py-28 px-6">
          <Utensils className="mx-auto mb-6 text-orange-400 w-14 h-14" />
          <h1 className="text-5xl font-extrabold text-white tracking-wide">
            Nuestra Historia
          </h1>
          <p className="mt-4 text-xl text-gray-200">
            Pasión y dedicación en cada platillo.
          </p>
        </div>
      </div>

      {/* Sección principal */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-16 items-center">
          {/* Texto */}
          <div>
            <h2 className="text-3xl font-extrabold text-gray-900">
              El Corazón de Nuestra Cocina
            </h2>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              Con más de 25 años de experiencia, transformamos eventos en
              momentos inolvidables a través de la alta cocina.
            </p>

            <h3 className="text-2xl font-bold text-gray-800 mt-8 mb-6">
              Ofrecemos:
            </h3>
            <ul className="space-y-4 text-lg text-gray-700">
              <li className="flex items-center gap-3">
                <CheckCircle className="text-orange-500" /> Servicios completos
                con meseros, cubertería y más.
              </li>
              <li className="flex items-center gap-3">
                <Coffee className="text-orange-500" /> Servicio de cafetería en
                colegios y empresas.
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-orange-500" /> Desayunos y
                almuerzos.
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-orange-500" /> Break sencillo y
                doble.
              </li>
              <li className="flex items-center gap-3">
                <CakeSlice className="text-orange-500" /> Postres salados y
                dulces.
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-orange-500" /> Boquitas de todo
                tipo.
              </li>
            </ul>
          </div>

          {/* Imagen */}
          <div className="flex justify-center">
            {loading ? (
              <div className="w-96 h-96 bg-gray-300 animate-pulse rounded-full"></div>
            ) : (
              <img
                src={nosotrosImageUrl}
                alt="El Chef"
                className="w-96 h-96 object-cover rounded-full shadow-2xl border-4 border-orange-500"
              />
            )}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gradient-to-r from-orange-500 to-red-500">
        <div className="max-w-4xl mx-auto text-center py-20 px-6">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            ¿Listo para planificar tu próximo evento?
          </h2>
          <Link
            to="/contacto"
            className="mt-8 inline-block px-8 py-4 bg-white text-orange-600 font-semibold rounded-xl shadow-lg hover:scale-105 transform transition"
          >
            Contáctanos
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Nosotros;
